import { Injectable } from '@angular/core';
import { ApiService } from '../api/api.service';
import { Observable } from 'rxjs';
import { FrontpageAlertData } from '@mwe/models';
import { FaqData } from '../../model/faq.model';

@Injectable({
  providedIn: 'root',
})
export class IkpStaticContentService extends ApiService {
  getTemporaryAlert(): Observable<FrontpageAlertData> {
    return this.httpClient.get<FrontpageAlertData>(`${this.staticContentUrl}/config/frontpage-alert.json`);
  }

  getStaticFAQs(): Observable<FaqData[]> {
    return this.httpClient.get<FaqData[]>(`${this.staticContentUrl}/faq/faqs-with-categories.json`);
  }
}
